

























import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-mapping-reports/keys'
import PatientStatsMappingHeading from '@/components/patient-stats/PatientStatsMappingHeading.vue'
import PatientStatsMappingChart from '@/components/patient-stats/graphs/PatientStatsMappingChart.vue'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import moment from 'moment-timezone'
import { FlatPatientWithMappingReports } from '@/store/modules/patient-with-mapping-reports/getters'

export default Vue.extend({
  components: {
    PatientStatsMappingHeading,
    PatientStatsMappingChart,
  },
  inheritAttrs: false,
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithMappingReports, [GetterNames.patientWithMappingReports]),
    patientWithMappingReports(): FlatPatientWithMappingReports {
      return this[GetterNames.patientWithMappingReports].find(patientWithMR => patientWithMR.id === this.patientId)
    },
    showChart() {
      if (!this.patientWithMappingReports) {
        return false
      }

      const { inhalerUsages, combinedWalkingDuration, sleepingPeriods, majorInterruptions } = this
        .patientWithMappingReports as FlatPatientWithMappingReports
      return (
        (inhalerUsages && inhalerUsages.length) ||
        (combinedWalkingDuration && combinedWalkingDuration.length) ||
        (sleepingPeriods && sleepingPeriods.length) ||
        (majorInterruptions && majorInterruptions.length)
      )
    },
  },
  watch: {
    async startTimestamp(n, o) {
      await this.fetchPatientWithMappingReport({ startTime: n })
    },
    async endTimestamp(n, o) {
      await this.fetchPatientWithMappingReport({ endTime: n })
    },
  },
  async mounted() {
    await this.fetchPatientWithMappingReport()
    this.isInitialized = true
  },
  methods: {
    ...mapActions(ModuleNames.patientWithMappingReports, [ActionNames.getPatientWithMappingReportsById]),
    async fetchPatientWithMappingReport() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      await this[ActionNames.getPatientWithMappingReportsById]({
        patientId: this.patientId,
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: this.endTimestamp,
      })
    },
  },
})
